import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css'; //import MRT styles
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import './global.css';
import { DatesProvider } from '@mantine/dates';
import { MantineProvider } from '@mantine/core';
import { Toaster } from 'react-hot-toast';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
// import { registerSW } from 'virtual:pwa-register';
import ReactGA from 'react-ga4';

import { registerSW, RegisterSWOptions } from 'virtual:pwa-register';
import { ErrorProvider } from './contexts/ErrorContext';
import i18nConfig from '@/utils/translation/translationConfig';
import { theme } from './theme';
import { Router } from './Router';
import { TimezoneContextProvider } from './contexts/TimezoneContext';

ReactGA.initialize(import.meta.env.VITE_GA_KEY);

dayjs.extend(relativeTime);
const intervalMS = Math.floor(10 * 60 * 1000);

export default function App() {
  const { i18n: i18nextInstance } = useTranslation();
  dayjs.locale(i18nextInstance.language);

  useEffect(() => {
    document.documentElement.lang = i18nextInstance.language;
  }, [i18nextInstance.language]);

  const [showNeedRefresh, setShowNeedRefresh] = useState(false);
  const [updateSWFunction, setUpdateSWFunction] = useState<((reloadPage?: boolean) => void) | null>(
    null
  );

  useEffect(() => {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh: () => {
        console.log('onNeedRefresh');
        setShowNeedRefresh(true);
        // if (confirm('Hay una nueva versión disponible. ¿Deseas actualizar?')) {
        //   updateSW(true); // Forzar la actualización
        // }
      },
      onOfflineReady: () => {
        console.log('onOfflineReady');
      },
      onRegisteredSW: (swScriptUrl, registration) => {
        console.log('onRegisteredSW');
        // Forzar polling para la actualización del Service Worker inmediatamente después de registrarse
        if (registration) {
          setInterval(() => {
            console.log('polling');
            registration.update();
          }, intervalMS);
          updateSW(true);
        }
      },
      onRegisterError: (error: any) => {
        console.log('onRegisterError');
        console.error(error);
      },
    });
    setUpdateSWFunction(() => updateSW);
  }, []);

  return (
    <MantineProvider theme={theme}>
      <I18nextProvider i18n={i18nConfig}>
        <TimezoneContextProvider>
          <DatesProvider settings={{ locale: i18nextInstance.language }}>
            <ErrorProvider>
              {/* Componente de aviso de version??? */}
              <Router />
              {showNeedRefresh && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '98px',
                    right: '8px',
                    padding: '8px 12px',
                    borderRadius: '5px',
                    border: 'solid 1px lightgray',
                    background: 'white',
                    zIndex: '9999',
                  }}
                >
                  <h4>Hay una nueva versión disponible. ¿Deseas actualizar?</h4>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'right',
                      gap: '12px',

                      alignItems: 'center',
                    }}
                  >
                    <button
                      style={{
                        color: 'rgb(0, 81, 255)',
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        if (showNeedRefresh) setShowNeedRefresh(false);
                      }}
                    >
                      No
                    </button>
                    <button
                      style={{
                        background: 'rgb(0, 81, 255)',
                        borderRadius: '5px',
                        color: 'white',
                        fontWeight: 'bold',
                        padding: '6px 12px',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        if (updateSWFunction) updateSWFunction(true);
                      }}
                    >
                      Actualizar
                    </button>
                  </div>
                </div>
              )}
              <Toaster />
            </ErrorProvider>
          </DatesProvider>
        </TimezoneContextProvider>
      </I18nextProvider>
    </MantineProvider>
  );
}
